import { render } from "./Model.vue?vue&type=template&id=6e898a21&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"

import "./Model.vue?vue&type=style&index=0&id=6e898a21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e898a21"]])

export default __exports__